import { App, ConfigProvider, type ConfigProviderProps } from "antd"
import { useRef } from "react"

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const config = useRef<ConfigProviderProps>()

  if (!config.current) {
    config.current = {
      tag: {
        variant: "outlined"
      },
      theme: {
        token: {
          colorPrimary: getComputedStyle(
            document.documentElement
          ).getPropertyValue("--primary-color"),
          colorLink: getComputedStyle(
            document.documentElement
          ).getPropertyValue("--link-color"),
          fontFamily: `Rubik, -apple-system, BlinkMacSystemFont, "Segoe UI",
"Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
"Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
          colorSplit: getComputedStyle(
            document.documentElement
          ).getPropertyValue("--neutral-4-color"),
          fontWeightStrong: 500
        },
        components: {
          Tag: {
            defaultBg: "var(--neutral-2-color)"
          },
          Table: {
            cellFontSize: 13,
            rowExpandedBg: "white"
          },
          Segmented: {
            itemColor: getComputedStyle(
              document.documentElement
            ).getPropertyValue("--neutral-7-color")
          }
        }
      }
    }
  }

  const { tag, theme } = config.current

  return (
    <ConfigProvider tag={tag} theme={theme}>
      <App>{children}</App>
    </ConfigProvider>
  )
}

export default ThemeProvider
